'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

import MarketTransactionsLayout from '../MarketTransactionsLayout'

const MarketTransactionsError = () => {
  return (
    <MarketTransactionsLayout>
      <ErrorDataUnavailable minHeight="478px" />
    </MarketTransactionsLayout>
  )
}

export default memo(MarketTransactionsError)
